import type { GameState } from '../types';
import { CHILL_KEY } from '../game/constants';
import { MAX_SCORE, gradeForScore, totalScore } from '../game/killerNotes';
import { $ } from './dom';
import { buildShareString, shareOrCopy } from './share';

export function openModal(): void {
  $('modal-backdrop').hidden = false;
}

export function closeModal(): void {
  $('modal-backdrop').hidden = true;
}

let helpBodyHTML = '';
let helpTitle = '';

// Snapshot the original help content at boot so we can restore it after a
// win/loss modal has overwritten the modal body.
export function snapshotHelp(): void {
  helpBodyHTML = $('modal-body').innerHTML;
  helpTitle = $('modal-title').textContent ?? '';
}

export function restoreHelp(): void {
  $('modal-body').innerHTML = helpBodyHTML;
  $('modal-title').textContent = helpTitle;
  $('share-btn').hidden = true;
  wireChillToggle();
}

// The chill checkbox lives inside #modal-body, so it gets re-rendered every
// time we restoreHelp(). Re-bind the change listener each time and reflect
// the current localStorage value into the checkbox.
function wireChillToggle(): void {
  const cb = document.getElementById('chill-toggle') as HTMLInputElement | null;
  if (!cb) return;
  try {
    cb.checked = localStorage.getItem(CHILL_KEY) === '1';
  } catch {
    cb.checked = false;
  }
  cb.onchange = () => {
    try {
      if (cb.checked) localStorage.setItem(CHILL_KEY, '1');
      else localStorage.removeItem(CHILL_KEY);
    } catch {
      // ignore
    }
  };
}

export function showResult(state: GameState): void {
  const won = state.status === 'won';
  $('modal-title').textContent = won ? 'ROLL CREDITS' : 'CUT TO BLACK';

  const body = $('modal-body');
  body.innerHTML = '';

  const summary = document.createElement('p');
  summary.textContent = won
    ? state.puzzle.movie.win
    : `${state.puzzle.movie.lose}`;
  body.appendChild(summary);

  const score = totalScore(state);
  const grade = gradeForScore(score, won);
  const scoreEl = document.createElement('p');
  scoreEl.className = 'score';
  const gradeSpan = document.createElement('span');
  gradeSpan.className = 'grade';
  gradeSpan.textContent = grade;
  scoreEl.appendChild(gradeSpan);
  if (state.chillMode) {
    const tag = document.createElement('span');
    tag.className = 'score-num';
    tag.textContent = 'CHILL MODE';
    scoreEl.appendChild(tag);
  } else {
    const sp = document.createElement('span');
    sp.className = 'score-num';
    sp.textContent = `${score} / ${MAX_SCORE}`;
    scoreEl.appendChild(sp);
  }
  body.appendChild(scoreEl);

  const meta = document.createElement('p');
  meta.className = 'muted';
  meta.textContent = 'Next victim airs at midnight.';
  body.appendChild(meta);

  const btn = $('share-btn') as HTMLButtonElement;
  btn.hidden = false;
  btn.onclick = () => {
    void shareOrCopy(buildShareString(state));
  };

  openModal();
}
